module.exports = __webpack_public_path__ + "static/media/Map_gray.5e4837bd.svg";